module.exports = __webpack_public_path__ + "static/media/logo-cpr.3fff5178.jpg";